import { render, staticRenderFns } from "./ThgBatchDetailInformationPartnerDistributionCard.vue?vue&type=template&id=31901b1a&"
import script from "./ThgBatchDetailInformationPartnerDistributionCard.vue?vue&type=script&lang=ts&"
export * from "./ThgBatchDetailInformationPartnerDistributionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports